import blueprint from "./blueprint.js";
import city from "./city.js";
import farm from "./farm.js";
import home from "./home.js";
import pacman from "./pacman.js";
import superMario from "./super-mario.js";
import warcraft from "./warcraft.js";
import chase from "./chase.js";
import nuclear from "./nuclear.js";
import raceTrack from "./race-track.js";
import superMarket from "./super-market.js";

const categories = {
	home,
	pacman,
	superMario,
	warcraft,
	chase,
	nuclear,
	city,
	farm,
	superMarket,
	raceTrack,
	blueprint,
};

export default categories;
